let queue = Promise.resolve();
const isCartPage = window.location.href.indexOf("/cart") > -1;
/*********************************************************************************************
 * Initialize the Splide carousel for the cart section.
 *
 */
function mmInitSplideRea() {
	const id = ".splide-rea";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: "splide",
			autoplay: true,
			arrows: false,
			pagination: false,
			rewind: true,
			gap: 12,
			perPage: 1,
		}).mount();
	}
}

function mmInitSplideCross() {
	const id = ".splide-cross";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: "splide",
			arrows: false,
			pagination: false,
			rewind: true,
			gap: 12,
			perPage: 1,
		}).mount();
	}
}

/*********************************************************************************************
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
	let timeout;
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

/*********************************************************************************************
 * Get the full cart section ID from the DOM.
 *
 * @returns {HTMLElement} - The full cart section ID with the prefix.
 */
function mmCartSectionIdLong() {
	if (isCartPage) {
		return document.querySelector(".js-cart-page").id;
	}
	return document.querySelector(".mm-cart").id;
}

/*********************************************************************************************
 * Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
 *
 * @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
 */
function mmCartSectionId() {
	if (isCartPage) {
		return document.querySelector(".js-cart-page")?.id.replace("shopify-section-", "");
	}
	return document.querySelector(".mm-cart")?.id.replace("shopify-section-", "");
}

/*********************************************************************************************
 * Get the cart section element from the DOM.
 *
 * @returns {HTMLElement} - The cart section element.
 */
function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
	if (isCartPage) {
		return mmCartSectionElement().querySelector(".js-cart-product-container");
	}
	return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

/*********************************************************************************************
 * Get the cart item element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(line_index) {
	const itemEl = mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
	if(itemEl) {
		return itemEl;
	} else {
		console.warn('Cart item is not found');
		return null;
	}
}

/*********************************************************************************************
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(line_index) {
	const itemEl = mmCartItem(line_index);
	return itemEl.querySelector("[data-item-quantity]");
}

function mmCartItemInstallationId(line_index) {
	const itemEl = mmCartItem(line_index);
	return itemEl.dataset.installationId;
}

/*********************************************************************************************
 * Get the quantity of a specific cart item.
 *
 * @param {number} line_index - The line item index.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(line_index) {
	const quantityEl = mmCartItemQuantityEl(line_index);
	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} line_index - The line item index.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(line_index, newQuantity) {
	// Display quantity in front
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(line_index);
		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

/*********************************************************************************************
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
	const el = document.createElement("DIV");
	el.innerHTML = data.sections["mm-cart"];
	return el;
}

/*********************************************************************************************
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	if (isCartPage) {
		return el.querySelector(".js-cart-product-container");
	}
	return el.querySelector(".mm-dc-products-container");
}

/*********************************************************************************************
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
	return data;
}

/*********************************************************************************************
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data);
	return cartEl.querySelector("[data-cart-total-price]");
}

/*********************************************************************************************
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
	return data;
}

/*********************************************************************************************
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
	document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: {"Content-Type": "application/json"},
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			// mmLog(data);
			document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
			updateCartCount(data.item_count != null ? data.item_count : 0);
			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		});
}


/*********************************************************************************************
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
	return mmAPIRequest("GET", "cart.js");
}

/*********************************************************************************************
 * Open the cart drawer and fetch the latest cart data.
 */
function mmOpenCart() {
	if (isCartPage) {
		return;
	}

	mmGetCart();
	const cartFilter = document.querySelector(".mm-drawer-cart-filter");
	const html = document.querySelector("html");
	const filter = cartFilter?.querySelector(".mm-dc-filter-left");

	if (!cartFilter || !html || !filter) return;

	cartFilter.classList.add("mm-dc-is-open");
	html.classList.add("stop-scrolling");

	// Immediately ensure the background filter is active
	showBgFilter();

	// Adjust the z-index after a short delay
	setTimeout(() => {
		filter.style.zIndex = "var(--index)";
	}, 300);
}

/*********************************************************************************************
 * Close the cart drawer and allow page scrolling.
 *
 */
function mmCloseCart() {
	// hideBgFilter();
	document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
}

/*********************************************************************************************
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {	
	const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = data.sections[mmCartSectionId()];
	let selector = ".mm-dc-products-container";
	if (isCartPage) {
		selector = ".js-cart-page-inner";
	}
	const cartSection = mmCartSectionElement();
	const innerCart = cartSection.querySelector(selector);
	innerCart.innerHTML = newCartEl.querySelector(selector).innerHTML;

	// Update drawer's footer and bottom part
	if (!isCartPage) {
		const cartFooter = cartSection.querySelector(".mm-dc-footer-delivery-price");
		const cartBottom = cartSection.querySelector(".mm-dc-bottom");
		if (cartFooter) {
			cartFooter.innerHTML = newCartEl.querySelector(".mm-dc-footer-delivery-price").innerHTML;
		}
		if (cartBottom) {
			cartBottom.innerHTML = newCartEl.querySelector(".mm-dc-bottom").innerHTML;
		}
	}

	mmInitSplideRea();
	mmInitSplideCross();
  updateProgressBarProductForm();
  if (document.querySelector(".mm-block-remise-content") && !isCartPage) {
    initReductionTable();
  }
	if (isCartPage) {
		initCartReductionTable();
	}
	return data;
}

/**
 * Loads an image from the given src and returns a Promise resolving to the loaded
 * Image object.
 *
 * @param {string} url - The source of the image to load.
 * @returns {Promise<Image>} - A Promise resolving to the loaded Image object or
 *   rejecting with an error if the image fails to load.
 */
function loadImage(src) {
	return new Promise((resolve, reject) => {
		const image = new Image();
		image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
	});
}

/**
 * Open the atc pop-up and fill it with the given product data
 *
 * @param {{ productId: number, data: Object }} data - Cart items object.
 * @returns {Object} - The response data
 */
function openPopUp({ productId, data }) {
	if (!data || !data.items) {
		console.warn("No data passed to openPopUp");
		return;
	}

	window.atcPopUp = window.atcPopUp || document.getElementById("jsAtcPopUp");
	const element = window.atcPopUp;
	if (!element) {
		console.warn("No atcPopUp element found");
		return;
	}
	element.removeAttribute("data-active");

	const cartItems = Array.isArray(data.items) ? data.items : Array.from(data.items);
	const addedItem = cartItems.find((item) => item.id == productId);
	const imageContainer = element.querySelector(".js-image-container");
	const productTitleContainer = element.querySelector(".js-product-title-container");

	const imageSource = `${addedItem['featured_image']['url']}&width=300`;
	const imageAlt = addedItem['featured_image']['alt'];
	const productTitle = addedItem['title'];

	loadImage(imageSource)
		.then((image) => {
			imageContainer.src = image.src;
			imageContainer.alt = imageAlt;
			productTitleContainer.textContent = productTitle;
		
			setTimeout(() => element.setAttribute("data-active", ""), 300);
		}).catch((error) => {
			console.error(error);
		});
	return data;
}

/*********************************************************************************************
 * Add a product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {'drawer' | 'pop-up' | 'page'} [options.cartType] - Whether to open the cart drawer after adding the product.
 */
function mmAddProductToCart(productId, {quantity = 1, cartType = 'page'}, litrage = '', targetEl = null, sellingPlan = null) {
  let items = [];
	if (litrage === null || litrage === undefined) {
		litrage = '';
	}

	// Additionnal product if installation is enabled
	const installationInput = document.querySelector('[name="installation_product"]');
	let installationProductId = null;
	let installationRelativeTitle = null; // Declare the variable
	let installationProps = {};
	
	if (installationInput && installationInput.checked) {
		installationProductId = installationInput.value;
		installationRelativeTitle = installationInput?.dataset?.relativeTitle || null;
	
		if (installationProductId) {
			installationProps['installation'] = installationRelativeTitle;
			items.push({
				quantity: quantity, // Using quantity from the main product
				id: installationProductId,
				properties: installationProps
			});
		}
	}
	

	$(".recItems-qtys").each(function () {
		var qty = parseInt($(this).val());
		var rec_id = $(this).attr("id").replace("qty-", "");
		if (qty > 0) {
			items.push({
				quantity: qty,
				id: rec_id,
			});
		}
	});
	items.push({
		quantity: quantity,
		id: productId,
		selling_plan: sellingPlan,
		properties: {
			_litrage: litrage,
			_installationProductId: installationProductId || null
		},
	});

	toggleBusyState(targetEl, true);

	const sections = mmCartSectionId();

	let functionChain = mmAPIRequest("POST", "cart/add.js", {
		items,
		sections,
	});

	// Skip these steps if `sections` is undefined
	if (sections !== undefined) {
		functionChain = functionChain
			.then(refreshCartFromData)
			.then(mmAddOrRemoveFreeProducts);
	}

	functionChain
		.then((data) => {
			switch (cartType) {
				case 'drawer':
					setTimeout(mmOpenCart);
					break;
				case 'pop-up':
					mmGetCart();
					openPopUp({ productId, data });
					break;
				default:
					window.location.href = "/cart";
					break;
			}
		})
		.catch((error) => {
			console.log(error);
			alert(error.message);
			mmOpenCart();
			location.reload();
		})
		.finally(() => {
			toggleBusyState(targetEl, false);
		});
}

/*********************************************************************************************
 * Increase the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
async function mmIncreaseProductQuantity(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	const installationId = mmCartItemInstallationId(line_index);
	let installationItem = null;
	let installation_line_index = null;
	let newInstallationQuantity = null;

	const newQuantity = quantity + 1;
	mmSetCartItemQuantity(line_index, newQuantity);
	await mmQueuedPushNewQuantity(line_index, newQuantity);

	if (installationId) {
		installationItem = document.querySelector(`[data-cart-item-id="${installationId}"]`);
		installation_line_index = installationItem?.dataset?.lineIndex ? parseInt(installationItem.dataset.lineIndex, 10) : null;

		if(installation_line_index) {
			newInstallationQuantity = mmGetCartItemQuantity(installation_line_index) + 1;
	
			mmSetCartItemQuantity(installation_line_index, newInstallationQuantity);
			mmQueuedPushNewQuantity(installation_line_index, newInstallationQuantity);
		}
	}
}

/*********************************************************************************************
 * Decrease the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
async function mmDecreaseProductQuantity(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	const installationId = mmCartItemInstallationId(line_index);
	let installationItem = null;
	let installation_line_index = null;
	let newInstallationQuantity = null;

	const newQuantity = quantity - 1;
	mmSetCartItemQuantity(line_index, newQuantity);
	await mmQueuedPushNewQuantity(line_index, newQuantity);
	
	if (installationId) {
		installationItem = document.querySelector(`[data-cart-item-id="${installationId}"]`);
		installation_line_index = installationItem?.dataset?.lineIndex ? parseInt(installationItem.dataset.lineIndex, 10) : null;

		if(installation_line_index) {
			newInstallationQuantity = mmGetCartItemQuantity(installation_line_index) - 1;
	
			mmSetCartItemQuantity(installation_line_index, newInstallationQuantity);
			mmQueuedPushNewQuantity(installation_line_index, newInstallationQuantity);
		}
	}
}

/*********************************************************************************************
 * Remove a specific product from the cart.
 *
 * @param {number} line_index - The line item index.
 */
async function mmDestroyProductFromCart(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	const installationId = mmCartItemInstallationId(line_index);
	let installationItem = null;
	let installation_line_index = null;
	let newInstallationQuantity = null;
	const newQuantity = 0;
	
	mmSetCartItemQuantity(line_index, newQuantity);
	await mmQueuedPushNewQuantity(line_index, newQuantity);

	if (installationId) {
		let installationSelector = `[data-cart-item-id="${installationId}"]`;
		if (isCartPage) {
			installationSelector = `.js-cart-page-item[data-cart-item-id="${installationId}"]`;
		}
		installationItem = document.querySelector(`${installationSelector}`);
		
		installation_line_index = installationItem?.dataset?.lineIndex ? parseInt(installationItem.dataset.lineIndex, 10) : null;
		
		if(installation_line_index) {
			newInstallationQuantity = mmGetCartItemQuantity(installation_line_index) - quantity;
			mmSetCartItemQuantity(installation_line_index, newInstallationQuantity);
			mmQueuedPushNewQuantity(installation_line_index, newInstallationQuantity);
		}
	}
}

/*********************************************************************************************
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */

async function mmPushNewQuantity(line_index, newQnt) {
	try {
		const quantity = newQnt ? newQnt : mmGetCartItemQuantity(line_index);
			const data = await mmAPIRequest("POST", "cart/change.js", {
					line: line_index,
					quantity: quantity,
					sections: mmCartSectionId(),
			});

			await mmAddOrRemoveFreeProducts(data);
			await refreshCartFromData(data);
	} 
	catch (error) {
			console.error(error);
			// location.reload();
	}
}


/*********************************************************************************************
 * Remove a line item from the cart.
 *
 * @param {number|string} line_index - The index of the line item in the cart to be removed.
 */
function mmDestroyLineItemFromCart(line_index) {
	mmAPIRequest("POST", "cart/change.js", {
		line: parseInt(line_index),
		quantity: 0,
		sections: mmCartSectionId(),
	}).then(refreshCartFromData);
}

/*********************************************************************************************
 * Queue the update of a specific product's quantity in the cart.
 *
 * @param {number} line_index - The line item index.
 * @param {number} newQnt - The new quantity to set for the product.
 * @returns {Promise} - A promise that resolves when the quantity update is complete.
 */

async function mmQueuedPushNewQuantity(line_index, newQnt) {
	// Chain calls to mmPushNewQuantity
	queue = queue.then(() => mmPushNewQuantity(line_index, newQnt)).catch(console.error);
	return queue;
}

/*********************************************************************************************
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount(value) {
	const counters = document.querySelectorAll(".mm-cart-counter");

	counters.forEach(counter => {
		if (value > 0) {
			counter.classList.remove("mm-none");
			counter.innerText = value;
		} else {
			counter.classList.add("mm-none");
		}
	});
}

/*********************************************************************************************
 * Add or remove free products from the cart based on conditions.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function mmAddOrRemoveFreeProducts(data) {
	let sectionToUpdate = "mm-cart";
	if (isCartPage) {
		sectionToUpdate = "js-cart-page";
	}

	if (data.sections[sectionToUpdate]) {
		const el = mmCartHTMLFromData(data);
		const freeProductEls = el.querySelector("[data-free-products]");
		let freeProductCounts = 0;

		// creates an object like { 44058675: 1, 44058001: 0 }
		// where key is free product id and value, its quantity
		const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
			const productId = freeProductEl.dataset.variantId;
			const isFree = freeProductEl.dataset.freeProduct == "true";
			const itemEl = mmCartItem(productId);
			if (isFree) {
				freeProductCounts += 1;
			}
			if (itemEl && isFree) {
				console.log("do nothing, item is already added");
				// do nothing, item is already added
			} else if (itemEl && !isFree) {
				console.log("item is present but should be removed");
				// item is present but should be removed
				param[productId] = 0;
			} else if (!itemEl && isFree) {
				console.log("item is absent but should be added", productId);
				// item is absent but should be added
				param[productId] = 1;
			}
			return param;
		}, {});

		// Add or remove free products only if needed
		if (Object.keys(productsParams).length > 0) {
			console.log("productsParams", productsParams);
			mmAPIRequest("POST", "cart/update.js", {updates: productsParams, sections: mmCartSectionId()}).then(refreshCartFromData);
		}
	}
	return data;
}

/*********************************************************************************************
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, {quantity = 1, openCart = 'page'}, clickedElem) {
	// Debounce on the CTA
	clickedElem.innerText = "AJOUTÉ !";
	clickedElem.classList.add("mm-disabled");

	// Ajouter le free product
	mmAddProductToCart(productId, {cartType: 'page'});
}


/*********************************************************************************************
 * Loaded Listenner
 *
 */
window.addEventListener("DOMContentLoaded", (event) => {
	mmGetCart();
	if (isCartPage) {
		initCartReductionTable();
	}
});

document.addEventListener(
	"DOMContentLoaded",
	() => {
		mmInitSplideRea();
		mmInitSplideCross();
	},
	{once: true}
);


function mmLoadThis() {

}

function toggleBusyState(el, state) {
	if (!el) return;
	
	// Handle empty arrays
	if (Array.isArray(el) && el.length === 0) return;

	const elements = Array.isArray(el) ? el : [el];
	
	elements.forEach((element) => {
		if (element) {
			element.setAttribute('aria-busy', state);
		}
	});
}

function updateProgressBarProductForm (){
  const cartTotalPrice = document.querySelector(".mm-dc-footer-nb-products-price")?.dataset?.cartTotalPrice;
  const productFormTable = document.querySelector(".mm-block-remise-content");
  if (productFormTable && cartTotalPrice) {
    productFormTable.dataset.cartTotalPrice = cartTotalPrice;
  }
}

//Reduction table
function initCartReductionTable() {
	const reductionTableContainer = document.querySelector(".mm-block-remise-content");

	if (!reductionTableContainer) {
		return;
	}

	const cartTotalPrice = parseInt(reductionTableContainer.dataset.cartTotalPrice, 10) / 100;
	const reductionStep1 = reductionTableContainer.querySelector(".mm-pf-reduc-step-1");
	const reductionStep2 = reductionTableContainer.querySelector(".mm-pf-reduc-step-2");
	const reductionStep3 = reductionTableContainer.querySelector(".mm-pf-reduc-step-3");
	const remiseTitlePrice = document.querySelectorAll('.js-remise-title .js-remise-price');

	const priceStep1 = parseInt(reductionStep1.dataset.stepPrice, 10);
	const priceStep2 = parseInt(reductionStep2.dataset.stepPrice, 10);
	const priceStep3 = parseInt(reductionStep3.dataset.stepPrice, 10);
	
	let totalPriceReduction = cartTotalPrice;

	// Comparaison avec les steps
	if (totalPriceReduction >= priceStep2) {
		const priceToNextDiscount = priceStep3 - totalPriceReduction;

		if (remiseTitlePrice[2] && !isNaN(priceToNextDiscount)) {	
			remiseTitlePrice[2].innerHTML = priceToNextDiscount.toFixed(2).replace(".", ",") + "€";
		}
	} else if (totalPriceReduction >= priceStep1) {
		const priceToNextDiscount = priceStep2 - totalPriceReduction;

		if (remiseTitlePrice[1] && !isNaN(priceToNextDiscount)) {
			remiseTitlePrice[1].innerHTML = priceToNextDiscount.toFixed(2).replace(".", ",") + "€";
		}
	} else {
		const priceToNextDiscount = priceStep1 - totalPriceReduction;

		if (remiseTitlePrice[0] && !isNaN(priceToNextDiscount)) {	
			remiseTitlePrice[0].innerHTML = priceToNextDiscount.toFixed(2).replace(".", ",") + "€";
		}
	}
}
